<ng-template #bankAccountSettings>
  <div mat-dialog-title class="mat-dialog-title mb-0">
    <span class="dialog-title-label" *scText="rendering.fields.Title"></span>
    <button
      *ngIf="rendering.fields.HasCloseButtonInHeader.value"
      (click)="dialogRef.close()"
      class="btn btn-default"
    >
      <i class="icon-close"></i>
    </button>
  </div>
  <div mat-dialog-content class="mat-dialog-content pb-0 pl-0 pr-0">
    <form #bankAccountSettingsForm="ngForm">
      <table class="table table-striped">
        <colgroup>
          <col class="w-sm-33" />
          <col class="w-sm-50" />
          <col class="w-sm-16" />
        </colgroup>
        <thead>
          <tr>
            <th
              class="border-top-0"
              *ngFor="let item of tableColumns.fields.items"
            >
              <span *scText="item.fields.label"></span>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let product of portfolio.products; let i = index">
            <td class="text-color">{{ product.accountNumber }}</td>
            <td>
              <input
                type="text"
                class="form-control"
                [name]="'description' + i"
                [(ngModel)]="product.description"
                (change)="addToEdit(product)"
                abMinLengthTrim="2"
                maxlength="50"
                [pattern]="allowedCharactersRegex"
              />
              <span
                class="field-validation-error"
                *ngIf="
                  bankAccountSettingsForm.form.get('description' + i)?.errors
                    ?.pattern
                "
                >{{
                  formFields.genericErrors.invalidAccountNameCharacter.message
                }}</span
              >
              <span
                class="field-validation-error"
                *ngIf="
                  bankAccountSettingsForm.form.get('description' + i)?.errors
                    ?.minlength
                "
                >{{
                  formFields.genericErrors.invalidAccountNameRange.message
                }}</span
              >
            </td>
            <td>
              <mat-slide-toggle
                *ngIf="portfolio"
                class="slide-toggle big"
                [name]="'visible' + i"
                [(ngModel)]="product.visible"
                (change)="addToEdit(product)"
              ></mat-slide-toggle>
            </td>
          </tr>
        </tbody>
      </table>
    </form>
  </div>
  <div mat-dialog-actions class="mat-dialog-actions">
    <button
      class="btn btn-primary btn-mid btn-block btn-md-block-none"
      abButtonLoader
      (click)="submit()"
      [disabled]="
        bankAccountSettingsForm.pristine || bankAccountSettingsForm.invalid
      "
    >
      <span *scText="rendering.fields.SubmitButtonLabel"></span>
    </button>
    <ng-container *ngIf="rendering.fields.CancelButtonLabel.value !== ''">
      <button
        class="btn btn-link btn-with-icon btn-block btn-md-block-none"
        (click)="dialogRef.close()"
      >
        <span *scText="rendering.fields.CancelButtonLabel"></span>
      </button>
    </ng-container>
  </div>
</ng-template>
